module.exports = __webpack_public_path__ + "static/img/m_role.864cfc5.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/sy/m_role.png
// module id = vyoP
// module chunks = 7